import { TableState } from '@tanstack/react-table';
import '../list-price-simulation-table/list-price-simulation.scss';
import '../retail-price-simulation-table/retail-price-simulation.scss';
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useAppSelector } from 'src/hooks';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { getTableColumnData } from 'src/components/collapsible-table/table-column-prep';
import { makeDataForNonCollapseTable, getDataForEditedSimulatedRows } from 'src/components/collapsible-table/table-data-prep';
import {
  MODIFIED_ROW_INDICATOR_KEY,
  TableComponent
} from '../../types/generic-table.model';
import TableSkeletonContainer from '../simulation-table-container/table-skeleton';
import getOutputTableColumn from '../../../common/features/table/components/output-column-prep';

export default function OwnKpiSimulationTable({ columns, errorInDataFetch = false, externalColumnData, visibleColumns, activeHeader }) {
  const { tableMetadaData, outputColumnVisibilityState, isSKUEditedClick } = useAppSelector((state) => state.table);
  const { currentScenario } = useAppSelector((state) => state.simulatorHome);
  const isDemandTransferenceEnabled = currentScenario?.is_dt_enabled !== false;

  const filterOutDemandTransferenceRows = (tableRows) =>
    isDemandTransferenceEnabled
      ? tableRows
      : tableRows.filter(
        (row) =>
          row?.pricing_is_edited !== true &&
          row?.pricing_is_not_default !== true &&
          row?.pricing_is_user_input !== true
      );

  // Logic to prepare the table row data for collapsible table
  const rows = filterOutDemandTransferenceRows(
    makeDataForNonCollapseTable(tableMetadaData.row).sort(
      (p1, p2) => (p1.ppg > p2.ppg ? 1 : -1)
    )
  );

  const tableState: Partial<TableState> = {
    columnVisibility: outputColumnVisibilityState
  };

  if (errorInDataFetch) {
    return (
      <div style={{ textAlign: 'center' }}>
        <Typography variant='h6'>Error in fetching data</Typography>
      </div>
    );
  }

  const getRows = (tableRows) => {
    if (isSKUEditedClick) {
      return filterOutDemandTransferenceRows(
        makeDataForNonCollapseTable(
          getDataForEditedSimulatedRows(
            tableMetadaData,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_EDITED,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_NOT_DEFAULT,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_USER_INPUT
          )
          // eslint-disable-next-line no-nested-ternary
        ).sort((p1, p2) => (p1?.ppg || '').localeCompare(p2?.ppg || ''))
      );
    }
    return filterOutDemandTransferenceRows(tableRows);
  };

  return columns.length ? (
    <div>
      <CollapsibleTable
        setHeightExplicitly
        data={getRows(rows)}
        columns={columns}
        tableState={tableState}
        externalColumnData={externalColumnData}
        visibleColumns={visibleColumns}
        activeHeader={activeHeader}
      />
    </div>
  ) : (
    <TableSkeletonContainer rowLength={10} headerLength={6} />
  );
}

